module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padding-x",
    style: (("padding-top: " + (_vm.messageClose ? '0px' : '30px')))
  }, [(!_vm.messageClose) ? _c('order-message', {
    attrs: {
      "action-code": _vm.actionCode,
      "success": !_vm.order.gatewayErrorCode && !_vm.order.gatewayAuthorizationResponse.data
    },
    on: {
      "close-message": _vm.closeMessage
    }
  }) : _vm._e(), _vm._v(" "), _c('order-header', {
    attrs: {
      "success": !_vm.order.gatewayErrorCode && !_vm.order.gatewayAuthorizationResponse.data,
      "full-name": _vm.order.customer.typePerson.fullName,
      "order": _vm.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "order-row"
  }, [_c('order-detail', {
    attrs: {
      "products": _vm.order.details
    }
  }), _vm._v(" "), _c('order-summary', {
    attrs: {
      "amount": _vm.order.subtotal,
      "currency-symbol": _vm.getCurrencySymbol,
      "shipping-price": _vm.order.costShipping,
      "total": _vm.order.total
    }
  })], 1), _vm._v(" "), _c('order-footer', {
    attrs: {
      "account-name": _vm.accountName,
      "account-number": _vm.accountNumber,
      "billing": _vm.order.billing,
      "card-number": _vm.gatewayTransactionCardNumber,
      "customer": _vm.order.customer,
      "description": _vm.bankDescription,
      "dispatch-name": _vm.order.pickUpName,
      "flag-bill": !!_vm.order.flagBill,
      "logo-bank": _vm.logo,
      "payment-method": _vm.order.wayPayment.name,
      "warehouse-address": _vm.order.warehouseAddress,
      "gateway-transaction-id": _vm.gatewayTransactionId,
      "success": !_vm.order.gatewayErrorCode && !_vm.order.gatewayAuthorizationResponse.data
    }
  }), _vm._v(" "), _c('order-actions', {
    attrs: {
      "order-exist": _vm.orderExistValidate,
      "unpaid": _vm.order.paymentStateId === 1 || !!_vm.order.gatewayErrorCode
    },
    on: {
      "see-detail": function($event) {
        _vm.$router.push({
          name: 'order-details',
          params: {
            id: _vm.order.id
          }
        })
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d4ad3a4","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order-created.vue
// module id = 1135
// module chunks = 2